enum EventAction {
  Created = "created",
  Deleted = "deleted",
  DeletionQueued = "deletion_queued",
  Merged = "merged",
  Rescanned = "rescanned",
  RestorationQueued = "restoration_queued",
  Restored = "restored",
  Rotated = "rotated",
  Tagged = "tagged",
  Transferred = "transferred",
  Updated = "updated",
}

enum EventEntityType {
  AccountAttachment = "account_attachment",
  AccountFormTemplate = "account_form_template",
  AiPhotoTagging = "ai_photo_tagging",
  Attachment = "attachment",
  BuildingInformationModelCalibration = "building_information_model_calibration",
  BuildingInformationModelElevation = "building_information_model_elevation",
  DefaultCompany = "default_company",
  DefaultCompanyUser = "default_company_user",
  EntityTag = "entity_tag",
  EntityTagging = "entity_tagging",
  ExternalQrCodeLink = "external_qr_code_link",
  FillablePdfFormAttachment = "fillable_pdf_form_attachment",
  FillablePdfFormTemplateAttachment = "fillable_pdf_form_template_attachment",
  Floorplan = "floorplan",
  Form = "form",
  FormDocusignEnvelope = "form_docusign_envelope",
  FormTemplate = "form_template",
  Hyperlink = "hyperlink",
  Markup = "markup",
  MicrosoftProjectTaskSource = "microsoft_project_task_source",
  MultiHyperlink = "multi_hyperlink",
  PrimaveraTaskSource = "primavera_task_source",
  Project = "project",
  ProjectResource = "project_resource",
  ProjectResourceLink = "project_resource_link",
  ProjectTemplate = "project_template",
  ProjectTemplateChangeOrderCostSectionMarkupPreset = "project_template_change_order_cost_section_markup_preset",
  ProjectTemplateChangeOrderLineItemPreset = "project_template_change_order_line_item_preset",
  ProjectTemplateChangeOrderSubtotalMarkupPreset = "project_template_change_order_subtotal_markup_preset",
  ProjectTemplateChangeOrderTotalMarkupPreset = "project_template_change_order_total_markup_preset",
  ProjectTemplateChecklistLink = "project_template_checklist_link",
  ProjectTemplateEntityTag = "project_template_entity_tag",
  ProjectTemplateEntityTagging = "project_template_entity_tagging",
  ProjectTemplateFolder = "project_template_folder",
  ProjectTemplateFormTemplateLink = "project_template_form_template_link",
  ProjectTemplatePermission = "project_template_permission",
  ProjectTemplateReport = "project_template_report",
  ProjectTemplateStatus = "project_template_status",
  ProjectTemplateSubmittalApprovalType = "project_template_submittal_approval_type",
  ProjectTemplateSubmittalNumbering = "project_template_submittal_numbering",
  ProjectTemplateTaskType = "project_template_task_type",
  ProjectTemplateTaskTypeAttribute = "project_template_task_type_attribute",
  ProjectTemplateTeam = "project_template_team",
  ProjectTemplateUser = "project_template_user",
  ProjectsUser = "projects_user",
  Sheet = "sheet",
  SheetUpload = "sheet_upload",
  SpecUpload = "spec_upload",
  Task = "task",
  TaskCheckItem = "task_check_item",
  TaskPosition = "task_position",
  TaskRelation = "task_relation",
}

export { EventAction, EventEntityType };
